import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import SidebarLayout from '../../components/layout/sidebarLayout';
import {
  manageSidebarContent,
  findSelectionForPath,
  buildManagePath,
  DEFAULT_MANAGE_PATH,
} from '../../constants/sidebarContent';
import { useAuth0 } from '@auth0/auth0-react';
import { canUserAccess } from '../../utils/userAuthorization';

const Manage = () => {
  const navigate = useNavigate();
  const { user } = useAuth0();
  const [selected, setSelected] = useState<[number, number] | null>(null);
  const menuState = selected !== null;
  const { '*': splat } = useParams();

  useEffect(() => {
    if (!splat) {
      navigate(DEFAULT_MANAGE_PATH, { replace: true });
      return;
    }

    const option = splat.split('/')[0];
    const selection = findSelectionForPath(option, manageSidebarContent);

    if (
      selection === null ||
      !canUserAccess(user?.sub, manageSidebarContent[selection[0]].titles[selection[1]].allowedUserIds)
    ) {
      navigate(DEFAULT_MANAGE_PATH, { replace: true });
      return;
    }

    setSelected(selection);
  }, [splat, navigate, user?.sub]);

  const onSetSelected = (array: [number, number]) => {
    navigate(buildManagePath(array));
  };

  return (
    <SidebarLayout
      selected={selected}
      onSelect={onSetSelected}
      sidebarContent={manageSidebarContent}
    >
      {menuState && selected && canUserAccess(
        user?.sub,
        manageSidebarContent[selected[0]].titles[selected[1]].allowedUserIds
      ) && manageSidebarContent[selected[0]].titles[selected[1]].content}
    </SidebarLayout>
  );
};

export default Manage;
